import { render, staticRenderFns } from "./PayCountdown.vue?vue&type=template&id=38095afa&scoped=true"
import script from "./PayCountdown.vue?vue&type=script&lang=js"
export * from "./PayCountdown.vue?vue&type=script&lang=js"
import style0 from "./PayCountdown.vue?vue&type=style&index=0&id=38095afa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38095afa",
  null
  
)

export default component.exports